import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'py-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CheckboxComponent {
  @Input()
  showLabel: boolean;
  @Input()
  showLeftLabel: boolean;
  @Input()
  ariaLabelledBy?: string;
  @Input()
  skipLabelElement: boolean = false;
}
